import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { WordpressRetrieveService } from '../../wordpress-retrieve.service';

@Component({
  standalone : true,
  selector: 'app-full-list',
  templateUrl: './full-list.component.html',
  styleUrls: ['./full-list.component.css'],
  imports: [
    CommonModule,
    RouterModule
  ]
})

export class FullListComponent {
  allPosts : any;
  
  constructor(private service:WordpressRetrieveService) {
    this.allPosts = [];
  }
    ngOnInit(): void {
    this.service.getAllPosts().subscribe((result)=>{
      // console.log(result);
      this.allPosts = result;
    })
}
}
